<template v-if="ready">
    <b-card class="w-100 my-2" header-tag="header">
        <template #header>
            <b-row>
                <b-col class="col-12 text-start">
                    <span><small><i class="fas fa-traffic-light"></i> <b>{{ title }}</b></small></span>
                </b-col>
            </b-row>
        </template>
        <b-card-body style="overflow-y:auto;">
            <b-row>
                {{ sla.name }}
                <span class="fw-300">
                    <i> {{ sla.description }}</i>
                </span>
            </b-row>
            <b-list-group-item class="list-group-item-details p-0 pt-1 pb-1 border-none border-top">
                <b-row>
                    <b-col>
                        <span class="float-end">
                            {{ $t('Total') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span class="ms-2">
                            {{ $t('Hosts') }} {{ sla.hostsAndServicesOverview?.hosts?.totalHosts }}
                        </span>
                    </b-col>
                    <b-col>
                        <span class="ms-2">
                            {{ $t('Services') }} {{ sla.hostsAndServicesOverview?.services?.totalServices }}
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-badge :class="{'opacity-50': (slaAvailabilityView.hosts?.failed?.count === 0 && slaAvailabilityView.services?.failed?.count === 0)}"
                                 class="bg-danger w-100">
                            <i class="fas fa-bolt"></i> {{ $t('Failed') }}
                        </b-badge>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.hosts?.failed?.count > 0">
                            <router-link :to="{name: 'hostsIndex', query: {id: slaAvailabilityView.hosts?.failed?.ids}}"
                                         class="text-danger" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.hosts?.failed?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.hosts?.failed?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.hosts?.failed?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.hosts?.failed?.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.hosts?.failed?.percentage }}
                            </span>
                        </span>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.services?.failed?.count > 0">
                            <router-link
                                :to="{name: 'servicesIndex', query: {id: slaAvailabilityView.services?.failed?.ids}}"
                                class="text-danger" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.services?.failed?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.services?.failed?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.services?.failed?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.services?.failed?.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.services?.failed?.percentage }}
                            </span>
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-badge :class="{'opacity-50': (slaAvailabilityView.hosts?.warning?.count === 0 && slaAvailabilityView.services?.warning?.count === 0)}"
                                 class="bg-warning w-100">
                            <i class="fas fa-triangle-exclamation"></i> {{ $t('Warning') }}
                        </b-badge>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.hosts?.warning?.count > 0">
                            <router-link
                                :to="{name: 'hostsIndex', query: {id: slaAvailabilityView.hosts?.warning?.ids}}"
                                class="text-danger" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.hosts?.warning?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.hosts?.warning?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.hosts?.warning?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.hosts.warning.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.hosts.warning.percentage }}
                            </span>
                        </span>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.services?.warning?.count > 0">
                            <router-link
                                :to="{name: 'servicesIndex', query: {id: slaAvailabilityView.services?.warning?.ids}}"
                                class="text-primary" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.services?.warning?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.services?.warning?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.services?.warning?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.services.warning.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.services.warning.percentage }}
                            </span>
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-badge :class="{'opacity-50': (slaAvailabilityView.hosts?.passed?.count === 0 && slaAvailabilityView.services?.passed?.count === 0)}"
                                 class="bg-success w-100">
                            <i class="fas fa-check"></i> {{ $t('Passed') }}
                        </b-badge>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.hosts?.passed?.count > 0">
                            <router-link :to="{name: 'hostsIndex', query: {id: slaAvailabilityView.hosts?.passed?.ids}}"
                                         class="text-primary" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.hosts?.passed?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.hosts?.passed?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.hosts?.passed?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.hosts?.passed?.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.hosts?.passed?.percentage }}
                            </span>
                        </span>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.services?.passed?.count > 0">
                            <router-link
                                :to="{name: 'servicesIndex', query: {id: slaAvailabilityView.services?.passed?.ids}}"
                                class="text-primary" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.services?.passed?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.services?.passed?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.services?.passed?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.services?.passed?.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.services?.passed?.percentage }}
                            </span>
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-badge :class="{'opacity-50': (slaAvailabilityView.hosts?.not_calculated?.count === 0 && slaAvailabilityView.services?.not_calculated?.count === 0)}"
                                 class="bg-primary w-100">
                            <i class="fas fa-question"></i> {{ $t('Not calc.') }}
                        </b-badge>
                    </b-col>
                    <b-col>
                        <span v-if="slaAvailabilityView.hosts?.not_calculated?.count > 0">
                            <router-link
                                :to="{name: 'hostsIndex', query: {id: slaAvailabilityView.hosts?.not_calculated?.ids}}"
                                class="text-primary" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.hosts?.not_calculated?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.hosts?.not_calculated?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.hosts?.not_calculated?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.hosts?.not_calculated?.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.hosts?.not_calculated?.percentage }}
                            </span>
                        </span>
                    </b-col>
                    <b-col>

                        <span v-if="slaAvailabilityView.services?.not_calculated?.count > 0">
                            <router-link
                                :to="{name: 'servicesIndex', query: {id: slaAvailabilityView.services?.not_calculated?.ids}}"
                                class="text-primary" style="text-decoration: none;">
                                <span class="pointer ms-2">
                                    {{ slaAvailabilityView.services?.not_calculated?.count }}
                                    <span class="opacity-50 ms-2">
                                        {{ slaAvailabilityView.services?.not_calculated?.percentage }}
                                    </span>
                                </span>
                            </router-link>
                        </span>
                        <span v-if="slaAvailabilityView.services?.not_calculated?.count === 0" class="ms-2">
                            {{ slaAvailabilityView.services?.not_calculated?.count }}
                            <span class="opacity-50 ms-2">
                                {{ slaAvailabilityView.services?.not_calculated?.percentage }}
                            </span>
                        </span>

                    </b-col>
                </b-row>

            </b-list-group-item>

        </b-card-body>
    </b-card>
</template>
<script>
import { useToast } from 'vue-toastification';
import { BListGroup, BListGroupItem } from 'bootstrap-vue-next';

export default {
    name: "SlaWidget",
    components: {BListGroupItem, BListGroup},
    props: ['type_id', 'widget_id', 'title'],

    data() {
        return {
            ready: true,
            error: false,
            sla: {},
            slaAvailabilityView: {}
        }
    },
    mounted() {
        this.getWidget();
    },
    methods: {

        getWidget: function() {
            axios.post('/dashboards/getSlaWidget.json', null, {
                params: {
                    id: this.widget_id
                }
            }).then(result => {
                this.sla = result.data.widgetData.sla || {};
                this.slaAvailabilityView = result.data.widgetData.sla?.hostsAndServicesOverview || {};
            }).catch(error => {
                console.log(error)
            });
        }
    },
    computed: {}
}
</script>

<style scoped>
.bg-primary {
    background-color: #5856d6 !important;
}

.fw-300 {
    font-weight: 300 !important;
}

</style>